export default function EULA() {
  return (
    <div className="min-h-screen bg-brand-50">
      <section className="pt-32 pb-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-brand-900 mb-8 tracking-tight">
            End User License Agreement
          </h1>

          <p className="text-sm text-brand-500 mb-12">
            Last updated: March 1, 2026
          </p>

          <div className="prose prose-lg max-w-none text-brand-700 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">1. Agreement to Terms</h2>
              <p className="leading-relaxed">
                This End User License Agreement ("Agreement") is a legal agreement between you and Pabs ("Company," "we," "us," or "our") for the use of the Pabs platform and related services (collectively, the "Service"). By accessing or using the Service, you agree to be bound by this Agreement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">2. License Grant</h2>
              <p className="leading-relaxed">
                Subject to your compliance with this Agreement, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Service for your internal business purposes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">3. Restrictions</h2>
              <p className="leading-relaxed mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Copy, modify, or create derivative works of the Service</li>
                <li>Reverse engineer, decompile, or disassemble the Service</li>
                <li>Rent, lease, lend, sell, or sublicense the Service</li>
                <li>Use the Service for any unlawful purpose</li>
                <li>Remove or alter any proprietary notices on the Service</li>
                <li>Use the Service in any manner that could damage, disable, or impair the Service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">4. Intellectual Property</h2>
              <p className="leading-relaxed">
                The Service and all related intellectual property rights are and will remain the exclusive property of Pabs and its licensors. This Agreement does not grant you any rights to our trademarks, service marks, or logos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">5. User Content</h2>
              <p className="leading-relaxed">
                You retain all rights to the content, data, and information you submit to the Service ("User Content"). By submitting User Content, you grant us a limited license to use, store, and process your User Content solely to provide the Service to you. We will not use your User Content to train AI models or for any other purpose without your explicit consent.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">6. Privacy and Data Security</h2>
              <p className="leading-relaxed">
                Your use of the Service is also governed by our Privacy Policy. We implement industry-standard security measures, including AES-256 encryption at rest and TLS 1.3 in transit, to protect your data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">7. Disclaimer of Warranties</h2>
              <p className="leading-relaxed">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">8. Limitation of Liability</h2>
              <p className="leading-relaxed">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL PABS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">9. Term and Termination</h2>
              <p className="leading-relaxed">
                This Agreement begins when you first access the Service and continues until terminated. We may terminate or suspend your access to the Service at any time, with or without cause, with or without notice. Upon termination, your right to use the Service will immediately cease.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">10. Changes to This Agreement</h2>
              <p className="leading-relaxed">
                We reserve the right to modify this Agreement at any time. We will notify you of any material changes by posting the new Agreement on this page and updating the "Last updated" date. Your continued use of the Service after such changes constitutes your acceptance of the new Agreement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">11. Governing Law</h2>
              <p className="leading-relaxed">
                This Agreement shall be governed by and construed in accordance with the laws of the jurisdiction in which Pabs is registered, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-brand-900 mb-4">12. Contact Information</h2>
              <p className="leading-relaxed">
                If you have any questions about this Agreement, please contact us through our{' '}
                <a href="/contact" className="text-brand-600 hover:text-brand-900 underline">
                  contact page
                </a>.
              </p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
}
